// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3xa5j","inner":"Form_inner__3cIA7","range":"Form_range__1vl-g","name":"Form_name__2CuDV","actions":"Form_actions__-x9ER"};